import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, User, Shield } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import '../styles/MobileBottomNav.css';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    if (path === '/dashboard?tab=profile') {
      return location.pathname === '/dashboard' && location.search.includes('tab=profile');
    }
    if (path === '/login') return location.pathname === '/login';
    return location.pathname === path;
  };

  const openVisaStatus = () => {
    window.dispatchEvent(new Event('open-visa-status'));
  };

  return (
    <nav className="mobile-bottom-nav" data-testid="mobile-bottom-nav">
      <button 
        className={`bottom-nav-item ${isActive('/') ? 'active' : ''}`}
        onClick={() => navigate('/')}
        data-testid="nav-home"
      >
        <Home size={22} />
        <span>{t('home') || 'Home'}</span>
      </button>

      <button 
        className={`bottom-nav-item ${isActive(isAuthenticated ? '/dashboard?tab=profile' : '/login') ? 'active' : ''}`}
        onClick={() => navigate(isAuthenticated ? '/dashboard?tab=profile' : '/login')}
        data-testid="nav-profile"
      >
        <User size={22} />
        <span>{isAuthenticated ? t('profile') || 'My Profile' : t('login') || 'Login'}</span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
